import { useGetProductionsInPeriod } from "@/orval/gen"
import { MultiSelect, MultiSelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"

interface Props extends Omit<MultiSelectProps, "data" | "value" | "onChange"> {
  period: { start?: string | null | undefined; end?: string | null | undefined }
  value?: number[] | null | undefined
  onChange?: (value: number[] | undefined) => void
}
export function ProductionMultiSelect({
  period,
  value,
  onChange,
  ...multiSelectProps
}: Props) {
  const { t } = useTranslation("app_server")
  const { data: productions, isLoading } = useGetProductionsInPeriod({
    end: period.end ?? undefined,
    start: period.start ?? undefined,
  })
  const options =
    productions?.map((production) => ({
      value: production.productionId.toString(),
      label: production.title,
    })) ?? []
  return (
    <MultiSelect
      loading={isLoading}
      label={t("Productions")}
      data={options}
      value={value?.map(String) ?? []}
      onChange={(val) => onChange?.(val?.map(Number))}
      {...multiSelectProps}
      defaultValue={
        multiSelectProps.defaultValue
          ? multiSelectProps.defaultValue.map(String)
          : undefined
      }
    />
  )
}
